import Dashboard from '../containers/dashboard'
import CustomerCompanyFundingsHistoryManagement from '../containers/customer-company-fundings-history-management'

const CustomerCompanyFundingsHistory = () => {
  return (
    <Dashboard>
      <CustomerCompanyFundingsHistoryManagement />
    </Dashboard>
  )
}

export default CustomerCompanyFundingsHistory
